var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGameFinished = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79621 16C13.1907 16 16.8 12.3983 16.8 8.00378C16.8 3.60925 13.1907 0 8.79621 0C4.40169 0 0.799988 3.60925 0.799988 8.00378C0.799988 12.3983 4.40924 16 8.79621 16ZM7.78441 12.0887C7.44463 12.0887 7.16525 11.9226 6.93873 11.6583L4.77167 9.08353C4.59046 8.87966 4.5225 8.67579 4.5225 8.44927C4.5225 7.96602 4.91514 7.58848 5.38328 7.58848C5.66266 7.58848 5.88163 7.7093 6.0855 7.93582L7.76931 9.97452L10.9935 4.86267C11.2049 4.53799 11.4541 4.37187 11.7636 4.37187C12.2242 4.37187 12.6471 4.71166 12.6471 5.1949C12.6471 5.38367 12.5716 5.59509 12.4432 5.79141L8.615 11.6206C8.41868 11.9151 8.11665 12.0887 7.78441 12.0887Z",
    fill: "#9CE39A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGameFinished);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gameFinished.288f3dfd111aa3893f48d202180eb301.svg";